module.exports = __webpack_public_path__ + "static/img/end-bg.93fc607.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/end-bg.png
// module id = iydp
// module chunks = 1